import { useBusinessesViewsGetLocationsForBusinessQuery } from "../airloom-generated-rtk";

export const useLocationsForBusiness = ({
  businessId,
}: {
  businessId: string;
}) => {
  const { data, isLoading, isError, refetch } =
    useBusinessesViewsGetLocationsForBusinessQuery(
      { businessId },
      { skip: !businessId },
    );

  return {
    locations: data?.locations,
    loading: isLoading,
    error: isError,
    refetch: refetch,
  };
};
